import { render, staticRenderFns } from "./OrderLayoutButton.vue?vue&type=template&id=30da958f"
import script from "./OrderLayoutButton.vue?vue&type=script&lang=js"
export * from "./OrderLayoutButton.vue?vue&type=script&lang=js"
import style0 from "./OrderLayoutButton.vue?vue&type=style&index=0&id=30da958f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports